/// <reference path="../../Common/Helpers/GridEditorDialog.ts" />

namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrdershippingBooksEditDialog extends Common.GridEditorDialog<OrdershippingBooksRow> {
        protected getFormKey() { return OrdershippingBooksForm.formKey; }
        protected getLocalTextPrefix() { return OrdershippingBooksRow.localTextPrefix; }

        protected form: OrdershippingBooksForm;
        public vOrderId: number;
        constructor() {
            super();
            
            this.form = new OrdershippingBooksForm(this.idPrefix);
            
            //this.form.ProductId.changeSelect2(e => {
            //    try {
            //        debugger;
            //        var strudentId = this.form.ProductId.value;
            //        //var ProductId = this.form.ProductId.value;
            //        if (parseInt(strudentId) == 0) {
            //            //this.setProductDetails({});
            //            return;
            //        }
            //        else {
            //            debugger;

            //            var productName = Q.first(Products.ProductsRow.getLookup().items, x => x.ProductId == Number(strudentId)).ProductName;
            //            this.form.ProductProductName.value = productName.toString();
            //        }
            //    } catch (e) {
            //        alert(e.message);
            //        debugger;
            //    }
            //});
            //this.form.ProductBookid.changeSelect2(e => {
            //    try {
            //        debugger;
            //        var productBookidId = this.form.ProductBookid.value;
            //        //var ProductId = this.form.ProductId.value;
            //        if (parseInt(productBookidId) == 0) {
            //            //this.setProductDetails({});
            //            return;
            //        }
            //        else {
            //            debugger;

            //            var bookId = Q.first(Products.ProductBooksRow.getLookup().items, x => x.ProductBookId == Number(productBookidId)).BookId;
            //            var Bookname = Q.first(Products.BooksRow.getLookup().items, x => x.BookId == Number(bookId)).BookName;
            //            this.form.ProductBookBookName.value = Bookname.toString();
            //        }
            //    } catch (e) {
            //        alert(e.message);
            //        debugger;
            //    }
            //});
            
           
        }
        loadEntity(entity: OrdershippingBooksRow) {
            debugger;
            super.loadEntity(entity);
            try {
                if (this.isNewOrDeleted) {
                    Q.reloadLookup("Orders.Orders");
                    this.form.OrderId.value = this.vOrderId.toString();                   
                    //this.form.ProductId.cascadeField = "OrderId";
                    //this.form.ProductId.cascadeValue = this.form.OrderId.value;
                    //Serenity.EditorUtils.setReadonly(this.form.OrderId.element, true);
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.OrderId.element, true);
                    
                }
            } catch (e) {
            }

        }
    }
}